import React, { useEffect, useState } from 'react';
import * as THREE from 'three';
import './IntroSequence.css';

const IntroSequence = ({ onComplete }) => {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const canvas = document.getElementById('universeCanvas');
    const container = document.getElementById('three-container');
    const ctx = canvas.getContext('2d');
    let width = canvas.width = window.innerWidth;
    let height = canvas.height = window.innerHeight;

    const stars = [];
    const numStars = 1000;
    const centerX = width / 2;
    const centerY = height / 2;

    for (let i = 0; i < numStars; i++) {
      stars.push({
        x: Math.random() * width - centerX,
        y: Math.random() * height - centerY,
        z: Math.random() * width
      });
    }

    function drawWarpSpeed() {
      ctx.fillStyle = "rgba(0, 0, 0, 0.2)";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      stars.forEach((star) => {
        const scale = width / star.z;
        const x = centerX + star.x * scale;
        const y = centerY + star.y * scale;
        const size = Math.max(1, 2 / star.z);
        ctx.beginPath();
        ctx.arc(x, y, size, 0, Math.PI * 2);
        ctx.fillStyle = "white";
        ctx.fill();
        star.z -= 5;
        if (star.z <= 0) {
          star.x = Math.random() * width - centerX;
          star.y = Math.random() * height - centerY;
          star.z = width;
        }
      });
    }

    function animateStars() {
      drawWarpSpeed();
      starAnimId = requestAnimationFrame(animateStars);
    }

    let starAnimId = requestAnimationFrame(animateStars);

    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(75, width / height, 0.1, 1000);
    const renderer = new THREE.WebGLRenderer({ alpha: true, antialias: true });
    renderer.setSize(width, height);
    container.appendChild(renderer.domElement);

    const loader = new THREE.TextureLoader();
    loader.load('/images/black_space.gif', (texture) => {
      const geometry = new THREE.BoxGeometry(1.5, 1.5, 1.5);
      const material = new THREE.MeshBasicMaterial({ map: texture });
      const cube = new THREE.Mesh(geometry, material);
      scene.add(cube);
      camera.position.z = 5;

      let animId;
      const animateCube = () => {
        cube.rotation.y += 0.01;
        cube.rotation.x += 0.005;
        renderer.render(scene, camera);
        animId = requestAnimationFrame(animateCube);
      };
      animateCube();

      // Show Enter button after 4.5s
      setTimeout(() => {
        setShowButton(true);
      }, 4500);
    });

    return () => {
      cancelAnimationFrame(starAnimId);
    };
  }, []);

  return (
    <>
      <canvas id="universeCanvas"></canvas>
      <div id="three-container"></div>
      {showButton && (
        <button className="intro-enter-btn" onClick={onComplete}>
          Enter Site
        </button>
      )}
    </>
  );
};

export default IntroSequence;
